module.exports = __webpack_public_path__ + "img/tvoc.2d5f71cd.svg";